const youtubeRE =
  /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]+).*/
const vimeoRE =
  /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\\-]+)?/i

export function extractYoutubeId(url: string): string | undefined {
  const match = youtubeRE.exec(url)
  return match !== null ? match[1] : undefined
}

export function extractVimeoId(url: string): string | undefined {
  const match = vimeoRE.exec(url)
  return match !== null ? match[1] : undefined
}
